/**
 * Why a track will not play, in words a streamer can act on.
 *
 * The site sends a code (reason_if_blocked) and, since the free-licence gate,
 * its own plain-language line (reason_label) on both the playlist rows and the
 * clearance response. The site's line wins, so there is one wording; this map
 * covers an older backend and any code sent without a line.
 */
const TEXT = {
  artist_removed: 'No longer on Sync.Land',
  artist_paused:  'Paused by the artist',
  on_hold:        'On hold for a routine check',
  file_check:     'On hold while its audio file is checked',
  not_offered:    'Not offered for streams',
  unavailable:    'Licensing is not available right now',
  free_tier_off:  'The artist does not offer the free licence for this track',
  no_audio:       'No audio file yet',
  no_license:     'Not licensed for streaming',
};

/** @param {{reason_if_blocked?: string, reason_label?: string}|null} o */
export function reasonText(o) {
  const label = o && typeof o.reason_label === 'string' ? o.reason_label.trim() : '';
  if (label) return label;
  const code = o && o.reason_if_blocked;
  return (code && TEXT[code]) || TEXT.no_license;
}
